import ParcelexApi from '@/services/parcelex';
import isMobile from '@/lib/isMobile';

export default {
  options({ device, apiKey, user, order, sessionId, trackId, extraOptionData, paymentAttemptId }) {
    const { shipping, products } = order;
    const deviceToSend = (device || (isMobile() ? 'mobile' : 'desktop')) === 'desktop'
      ? 'desktop' : 'mobile';
    const apiData = {
      apiKey,
      device: deviceToSend,
      sessionId,
      // user
      phone: user.phone,
      cpf: user.cpf,
      email: user.email,
      // shipping
      shipping: shipping.value,
      zipCode: shipping.zipcode,
      addressStreet: shipping.addressStreet,
      addressNumber: shipping.addressNumber,
      addressComplement: shipping.addressComplement || '',
      city: shipping.city,
      state: shipping.state,
      source: 'checkout',
      trackId,
    };

    if (paymentAttemptId) {
      apiData.additionalOptions = {
        payment: {
          attemptId: paymentAttemptId,
        },
      };
    }

    if (extraOptionData) {
      apiData[extraOptionData.key] = extraOptionData.value;
    }

    // product
    const product = products[0];
    apiData.products = products;
    apiData.productAmount = product.amount;
    apiData.productPrice = product.value;

    apiData.skuNumber = product.id;
    apiData.productName = product.name;
    apiData.productDescription = product.description;
    apiData.productImage = product.image;
    apiData.productUrl = product.url;
    apiData.categoryName = product.category;
    apiData.categoryId = product.categoryId;
    apiData.seller = product.seller;

    return ParcelexApi.post('/public/options', apiData);
  },
  preview(data) {
    return ParcelexApi.post('/public/preview', data);
  },
  getVtexData({ paymentId, apiKey }) {
    return ParcelexApi.post('/vtex/fallback/data', { paymentId, apiKey });
  },
};
